import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CalculatedAttributeCreateNRO = lazy(() =>
  import("@segments/CalculatedAttributeEdit").then((module) => ({
    default: module.CalculatedAttributeCreateNRO,
  }))
);

export const calculatedAttributesCreateNRO: NavigationRoutingObject = {
  Component: CalculatedAttributeCreateNRO,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("calculated-attributes-create-heading", "Create Calculated Attribute"),
  pageNameForTracking: () => "Create Calculated Attribute",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("calculated-attributes-create-description", "Create a calculated attribute"),
  icon: "nav-system-calculated-attributes",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("custom_calculated_attributes");
  },
  showInSearchResults: false,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/calculated_attributes/:appGroupId",
};
